import Vue from 'vue'
import { Toast, Dialog } from 'vant'
import { mapGetters, mapActions } from 'vuex'
import { applyShoppingSms } from '~fetch/common'
import { theme, hexToRGBA } from './../assets/styles/theme.js'

Vue.use(Toast)
  .use(Dialog)
export default {
  computed: {
    ...mapGetters(['getLoginStatus', 'getLoadSettingStatus'])
  },
  created () {

  },
  methods: {
    ...mapActions(['CART_GETNUM', 'LOAD_SETTING_DATA']),
    async getSetting () {
      await this.LOAD_SETTING_DATA()
      let { data } = this.getLoadSettingStatus
      var colorOpacity5 = hexToRGBA(data.style_setting.APP_theme_color, '0.5')
      var colorOpacity1 = hexToRGBA(data.style_setting.APP_theme_color, '0.1')
      let colorOpacity7 = hexToRGBA(data.style_setting.APP_theme_color, '0.7')
      let colorOpacity3 = hexToRGBA(data.style_setting.APP_theme_color, '0.3')
      theme(data.style_setting.APP_login_btn_color, data.style_setting.APP_theme_color, data.style_setting.APP_theme_font_color, colorOpacity5, colorOpacity1,colorOpacity3, colorOpacity7)
    },
    /**
     * @description 预售支付定金(预售专区重构之后就del)
     * @author cc
     * @date 2019-11-11
     * @param {data} id 商品id
     * @param {data} presell_id 预售id
     * @param {data} payment_type 预售模式（全款，定金）
     * @param {data} num 购买的数量
     * @param {data} presellStock 预售库存
     * @param {data} isView 是否是区域经销(首页的为你推荐中的区域经销是过滤掉了)
     */
    async payMoney (id, presellId, paymentType, num, presellStock, isView) {
      let { data } = await this.getLoginStatus
      if (data.member_id.toString() === '0') {
        Toast('亲，登录后才能操作')
        return false
      }
      if (data.role.toString() === '3') {
        Toast('分销商不可购物')
        return false
      }
      let res = await this.getLoadSettingStatus

      if (res.data.is_delivery_flag === 1) {
        Toast('配送商品不参与预售活动')
        return false
      }
      // 区域经销(后续做快捷采购待完善，首页没有)
      if (isView && isView === 1) {
        Toast('区域经销')
        return false
      }
      if (presellStock * 1 > 0) {
        window.location =
          '/cart/index?goods_id=' +
          id +
          '&presell_id=' +
          presellId +
          '&payment_type=' +
          paymentType +
          '&quantity=' +
          num +
          '&is_presell=1'
      }
    },
    /**
     * @description 实时购物车数量
     * @author cc
     * @date 2019-11-13
     * @param {data} item 商品
     */
    async cartGetnum () {
      var now = (new Date()).valueOf()
      this.CART_GETNUM({ rand: now })
    },
    /**
     * @description 添加商品字段，并对字段进行处理
     * @author cc
     * @date 2019-11-13
     * @param {data} goodData 商品数据
     */
    addGoodField (goodData, type) {
      var arr = goodData.map(item => {
        if (this.getLoadSettingStatus.data.is_delivery_flag) {
          this.$set(item, 'jiage', '配送价')
          this.$set(item, 'shanchu_price', '配送价')
        }
        // price 是普通价格 jiage是预售价 区域经销>预售>议价商品
        // 根据后台的控制，对商品价格小数点保留几位的处理
        if (item.jiage) {
          item.jiage = isNaN(item.jiage) ? item.jiage : this.float_change(item.jiage)
          item.shanchu_price = isNaN(item.shanchu_price) ? item.shanchu_price : this.float_change(item.shanchu_price)
          // 配送价
        }
        if (item.discount_prices) {
          item.discount_prices = isNaN(item.discount_prices) ? item.discount_prices : this.float_change(item.discount_prices)
        }
        // 根据后台的控制，对商品厂家，批号，原产地，折后价进行处理
        let arrname = ['showbatch_code', 'showsource_area', 'showproduce_unit', 'showdiscount_price', 'showproduct_name']
        arrname.forEach(name => {
          item[name] = true
        })
        this.not_show_field_arr && this.not_show_field_arr.forEach(ele => {
          if (item.hasOwnProperty(ele)) {
            item['show' + ele] = false
          }
          // 促销专区
          if (item.goods_list) {
            item.goods_list.forEach(good => {
              arrname.forEach(name => {
                good[name] = true
              })
              if (good.hasOwnProperty(ele)) {
                item['show' + ele] = false
              }
            })
          }
        })
        return item
      })
      return arr
      // 多批号
    },
    async applyBargain (item) {
      let data = await applyShoppingSms({
        goods_id: item.id,
        distributor_member_id: item.distributor_member_id
      })
      Dialog.confirm({
        message: `尊敬的用户 ，该商品为控销商品，请联系当地服务员：${data.distributor_info.contacter}  ${data.distributor_info.mobile} `,
        confirmButtonText: '拨打电话',
        cancelButtonText: '继续浏览'
      }).then(() => {
        window.location.href = 'tel://' + data.distributor_info.mobile
        // on confirm
      }).catch(() => {
        // on cancel
      })
    },
    search () {
      this.$router.push({ path: '/search' })
    }
  }
}
